import { numericFormatter } from 'react-number-format';

export const numberWithThousandSeparator = (data: string | number) => {
  return numericFormatter(data.toString(), { thousandSeparator: true });
};
